import sendUETAddToCartEvent from "analytics/bing/sendUETAddToCartEvent";
import { IAnanlyticsCompactProduct } from "api/interfaces/get-page-details/common/CompactProduct.type";
import { IVehicle } from "interfaces/session/IVehicle";
import { FACEBOOK_PIXEL_EVENT_NAME, fbPixelTrack } from "../../analytics/facebook/FacebookPixelEvent";
import EnhancedEcommerce, { sendGA4AddToCartEvent } from "../enhanced-ecommerce";
import { getPayload } from "./getPayload";
import { pushEngageAddToCartEvent } from "./pushengage";
import { trackEvents } from "./trackEvents";
import { TRACKING_EVENT_NAME } from "./tracking.service";

export function sendAddToCartEvent(product: IAnanlyticsCompactProduct, vehicle: IVehicle) {
  const payload = getPayload(undefined, product, vehicle);
  const { quantity } = product;
  const analyticsPayload = { ...payload, quantity };

  // gtag("event", TRACKING_EVENT_NAME.ADD_TO_CART, {
  //   send_to: GTAG_ID,
  //   productLine: payload.productLine,
  //   google_business_vertical: "custom",
  // });
  trackEvents(
    TRACKING_EVENT_NAME.ADD_TO_CART,
    "click",
    { product: analyticsPayload },
  );
  EnhancedEcommerce.addToCart(product);
  sendGA4AddToCartEvent(product);
  sendUETAddToCartEvent(product);
  fbPixelTrack(FACEBOOK_PIXEL_EVENT_NAME.ADD_TO_CART, ["content_ids", "content_name", "content_type",
    "contents", "currency", "value"], analyticsPayload);
  pushEngageAddToCartEvent(product, vehicle);
}
